import emailjs from 'emailjs-com';
import React, { useRef } from 'react';
import { Container } from 'react-bootstrap';
import './Contact.css';

 // dynamic React from which is integrate with Emailjs.com
 // Video Link : https://www.youtube.com/watch?v=NgWGllOjkbs

 const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();

      emailjs.sendForm('gmail', 'template_ukoc6so', e.target, 'user_G910stLlKU7Ybb3zu6sDJ')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset();
    };


    return (
    <div className="pt-5 pb-5 mt-5 contact-Main">  
       <Container>
        <div class="contact" id="contact">      
          <h3 class="contactText text-center">CONTACT<span className="purple"> ME</span>  </h3>
          <div class="row m-auto">
            <form onSubmit={sendEmail}>
                <input data-aos="fade-right" type="text"  name="name" placeholder="name" class="box"/>
                <input data-aos="fade-left" type="email" name="email" placeholder="email" class="box"/>          
                <input data-aos="fade-rigt" type="text"  name="subject" placeholder="subject" class="box"/>
                <textarea data-aos="fade-left" cols="30" name="message" rows="10" class="box message" type="text" placeholder="message"></textarea>
                <button data-aos="fade-up" type="submit" class="btn btn-primary text-white"> Send <i class="fas fa-paper-plane"></i> </button>
            </form>
          </div>
        </div>
       </Container>
     </div>
    );
};

export default Contact;